<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  getDays,
  updateAvaialability,
} from "../../../api/services/cafe.service";

/**
 * Manage Cafeteria Page
 */
export default {
  page: {
    title: "Manage Cafeteria",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      title: this.$i18n.t("cafe.header.title"),
      items: [
        {
          text: this.$i18n.t("cafe.header.item"),
          active: true,
        },
      ],
      cafeDays: null,
      cafeSaveSuccess: false,
      cafeSaveFailed: false,
    };
  },
  async mounted() {
    await this.getAllCafeDays();
  },
  methods: {
    async getAllCafeDays() {
      let getAllDaysFromDatabase = await getDays();
      if (getAllDaysFromDatabase) {
        for (let i = 0; i < getAllDaysFromDatabase.length; i++) {
          const openingTime = getAllDaysFromDatabase[i].openTime;
          let openDate = new Date(openingTime).toString();
          getAllDaysFromDatabase[i].openTime = openDate.slice(16, 22);

          const closingTime = getAllDaysFromDatabase[i].closeTime;
          let closingDate = new Date(closingTime).toString();
          getAllDaysFromDatabase[i].closeTime = closingDate.slice(16, 22);

          getAllDaysFromDatabase[i].enableEdit = false;
        }
        this.cafeDays = getAllDaysFromDatabase;
      }
    },
    async saveCafeEdits(dayToEdit, dayToEditIndex) {
      if (!dayToEdit.isClosed) {
        const todayDateForOpen = new Date();
        todayDateForOpen.setHours(dayToEdit.openTime.split(":")[0]);
        todayDateForOpen.setMinutes(dayToEdit.openTime.split(":")[1]);
        var openTimeToPass = todayDateForOpen;

        const todayDateForClose = new Date();
        todayDateForClose.setHours(dayToEdit.closeTime.split(":")[0]);
        todayDateForClose.setMinutes(dayToEdit.closeTime.split(":")[1]);
        var closeTimeToPass = todayDateForClose;
      }

      const dayToPass = {
        day: dayToEdit.day,
        isClosed: dayToEdit.isClosed,
        openTime: openTimeToPass,
        closeTime: closeTimeToPass,
      };

      let cafeTimeUpdateSuccess = await updateAvaialability(dayToPass);

      if (cafeTimeUpdateSuccess) {
        this.cafeSaveSuccess = true;
        this.cafeDays[dayToEditIndex].enableEdit = false;
      } else {
        this.cafeSaveFailed = true;
      }
    },
    clickEdit(dayToEditIndex) {
      this.cafeDays[dayToEditIndex].enableEdit = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <b-alert v-model="cafeSaveFailed" variant="danger" dismissible
          ><i class="bx bx-error-circle mr-2"></i
          >{{ $t("cafe.times.saveFailed") }}</b-alert
        >
        <b-alert v-model="cafeSaveSuccess" variant="success" dismissible
          ><i class="mdi mdi-check-all mr-2"></i
          >{{ $t("cafe.times.saveSuccess") }}</b-alert
        >
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-6"
        v-for="(cafe, cafeIndex) in cafeDays"
        :key="cafeIndex"
      >
        <b-card>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label> {{ cafe.dayDE }} </label>
            </div>
            <div class="col-md-6 mb-3">
              <b-form-checkbox
                v-model="cafe.isClosed"
                switch
                class="mb-1"
                :disabled="!cafe.enableEdit"
              >
                <label>{{ $t("cafe.times.toggel") }}</label>
              </b-form-checkbox>
            </div>
            <div class="col-md-12">
              <b-alert v-model="cafe.isClosed" variant="danger"
                ><i class="bx bx-error-circle mr-2"></i
                >{{ $t("cafe.times.cafeIsClosed") }}</b-alert
              >
            </div>
            <div class="col-md-6" v-if="!cafe.isClosed">
              <b-form-group>
                <date-picker
                  v-model="cafe.openTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  placeholder="hh:mm"
                  :disabled="!cafe.enableEdit"
                ></date-picker>
              </b-form-group>
            </div>
            <div class="col-md-6" v-if="!cafe.isClosed">
              <b-form-group>
                <date-picker
                  v-model="cafe.closeTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  placeholder="hh:mm"
                  :disabled="!cafe.enableEdit"
                ></date-picker>
              </b-form-group>
            </div>
            <div class="col-md-12 mt-2">
              <b-button
                v-if="cafe.enableEdit"
                variant="success"
                @click="saveCafeEdits(cafe, cafeIndex)"
              >
                <i class="bx bxs-save mr-1"></i>
                {{ $t("general.buttons.save") }}</b-button
              >
              <b-button v-else variant="warning" @click="clickEdit(cafeIndex)">
                <i class="bx bxs-pencil mr-1"></i>
                {{ $t("general.buttons.edit") }}</b-button
              >
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>
